export default {
  path: 'price-forecast',
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "financial-predictions-price-forecast" */ './PriceForecast')
}
